export class MockAIProvider {
    constructor() {
        this.models = [
            { id: 'gpt-4', name: 'GPT-4 (Simulated)' },
            { id: 'claude-3-opus', name: 'Claude 3 Opus (Simulated)' },
            { id: 'llama-3', name: 'Llama 3 (Simulated)' }
        ];
    }
    getModels() {
        return this.models;
    }
    async sendMessage(context, modelId) {
        // Simulate network delay (3 seconds as requested)
        await new Promise(resolve => setTimeout(resolve, 3000));
        const modelName = this.models.find(m => m.id === modelId)?.name || modelId;
        const latestUser = [...context.messages].reverse().find(message => message.role === 'user');
        // Handle both string and MessageContent[] types
        let text = '';
        if (typeof latestUser?.content === 'string') {
            text = latestUser.content;
        }
        else if (Array.isArray(latestUser?.content)) {
            // Extract text content from multimodal message
            text = latestUser.content
                .filter((c) => c.type === 'text' && c.text)
                .map((c) => c.text)
                .join(' ');
        }
        // Simple keyword-based responses to make it feel somewhat dynamic
        if (text.toLowerCase().includes('email') || text.includes('[EMAIL_')) {
            const emailTag = text.match(/\[EMAIL_\d+\]/)?.[0] || '[EMAIL_1]';
            return `[${modelName}] I received your message. I notice you mentioned an email address (${emailTag}). I can help you draft a response to ${emailTag} or manage your inbox.`;
        }
        if (text.toLowerCase().includes('bitcoin') || text.toLowerCase().includes('crypto') || text.includes('[CRYPTO_')) {
            const cryptoTag = text.match(/\[CRYPTO_\d+\]/)?.[0] || '[CRYPTO_1]';
            return `[${modelName}] It looks like you're dealing with cryptocurrency at ${cryptoTag}. Please be careful with wallet addresses and private keys!`;
        }
        if (text.toLowerCase().includes('phone') || text.includes('[PHONE_')) {
            const phoneTag = text.match(/\[PHONE_\d+\]/)?.[0] || '[PHONE_1]';
            return `[${modelName}] Thanks for the contact information (${phoneTag}). I'll store it for this demo.`;
        }
        const tagMatch = text.match(/\[[A-Z_]+\d+\]/);
        if (tagMatch) {
            return `[${modelName}] I processed your request containing ${tagMatch[0]}. \n\nThis is a simulated response where I echo back the tag to demonstrate deanonymization on the frontend.`;
        }
        return `[${modelName}] processed your request: "${text.substring(0, 50)}${text.length > 50 ? '...' : ''}". \n\nThis is a simulated response demonstrating that the anonymized data was received safely.`;
    }
}
